import { render, staticRenderFns } from "./AccountingAccountsTable.vue?vue&type=template&id=0f8923b8"
import script from "./AccountingAccountsTable.vue?vue&type=script&lang=js"
export * from "./AccountingAccountsTable.vue?vue&type=script&lang=js"
import style0 from "./AccountingAccountsTable.vue?vue&type=style&index=0&id=0f8923b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports